import { defineComponent } from 'vue'
import type { ExtractPropTypes, PropType, SlotsType } from 'vue'


export const pagetableColumnDiyProps = () => ({
  head: String,
  headAlign: String as PropType<'left' | 'right' | 'center'>,
  name: String,
  width: [String, Number],
  fixed: [Boolean, String],
  tail: [Boolean, String],
})

export type PagetableColumnDiyProps = Partial<ExtractPropTypes<ReturnType<typeof pagetableColumnDiyProps>>>

export default defineComponent({
  name: 'OPagetableColumnDiy',
  inheritAttrs: false,
  props: pagetableColumnDiyProps(),
  slots: Object as SlotsType<{
    default: any
  }>,
  setup(props, { slots, attrs, emit, expose }) {
    return () => null
  },
})
